import axios from "axios";

const {
  REACT_APP_API_URL: API_URL,
  REACT_APP_CONSUMER_PORTAL_API_KEY: CONSUMER_PORTAL_API_KEY,
} = process.env;

export const axiosAWSConsumer = axios.create({
  baseURL: API_URL,
  headers: {
    "X-API-KEY": CONSUMER_PORTAL_API_KEY,
  },
});
